import * as React from 'react';
import classNames from 'classnames';
import { withMemo } from 'PyzShopUi/scripts/react/common/hoc/withMemo';
import { ISelectFilterOption } from '../../../../../shop-ui/components/search-page/interfaces';

export interface IColorFilterOptionsProps {
    additionalClassName?: string;
    optionList: ISelectFilterOption[];

    onScrollChange?(event: React.UIEvent<HTMLUListElement, UIEvent>): void;

    onToggleItem?(value: string, isSelected: boolean): void;

    optionStyle?: React.CSSProperties;
}

const ColorFilterOptionsComponent: React.FunctionComponent<IColorFilterOptionsProps> = props => {
    const displayItems = () => (
        props.optionList.map(option => {
            const listItemClasses = classNames({
                checked: option.selected,
            });
            const labelClasses = classNames({
                disabled: option.disabled,
                multicolor: option.multicolor,
            });

            return (
                <li
                    key={option.value}
                    onClick={() => props.onToggleItem(option.value, option.selected)}
                    className={`grid-filter__item ${listItemClasses}`}
                    data-qa="color-filter-option"
                >
                    <label className={`${option.value} ${labelClasses} ${option.labelCssClass || ''}`} htmlFor={option.label + '_' + option.value}>
                        { option.multicolor ? <div style={option?.style}></div> : undefined }
                    </label>
                    <span>{option.label}</span>
                </li>
            );
        })
    );

    return (
        <ul onScroll={props.onScrollChange} className={`grid-filter ${props.additionalClassName}`}>
            {displayItems()}
        </ul>
    );
};

ColorFilterOptionsComponent.defaultProps = {
    additionalClassName: '',
    onScrollChange: () => ({}),
    onToggleItem: () => ({}),
};

const ColorFilterOptions = withMemo(ColorFilterOptionsComponent);

export default ColorFilterOptions;
